<template>
    <div>
        <div class="store-item">
            <div class="item-image">
                <img :src="'/item/image/'+item_id" class="profile-image">
            </div>
            <div class="item-info">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-year" v-if="item_type_view_status == 1">{{ item.on_sale_date }}</div>
                <div v-if="!checkIsDigitalContent(item.type)">
                    <div class="item-type" v-for="tab in tabs" v-if="tab.type===item.type && item_type_view_status == 1">
                        {{ characters[tab.type+'_type'] }}
                    </div>
                </div>
                <div v-if="checkIsDigitalContent(item.type)">
                    <div class="item-type" v-if="item.content_count>1">{{ characters.album }}({{ item.content_count }}{{ characters.number_of_music }})</div>
                    <div class="item-type" v-if="item.content_count==1">{{ characters.single }}</div>
                </div>
            </div>
        </div>

        <div v-if="!checkIsDigitalContent(item.type) || item.content_count<2">
            <section class="item-purchase" v-if="item.soldout_flag==0 && item.bought_flag==0">
                    <div>
                        <input type="hidden" name='id' :value="item.item_id">
                        <button class="btn btn-dark button" @click="add_cart()">{{ characters.add_cart }}</button>
                    </div>
                <div class="price ml-auto">{{ '￥' + item.price }}</div>
            </section>
            <section class="item-purchase" v-if="item.soldout_flag==1">
                    <div>
                        <input type="hidden" name='id' :value="item.item_id">
                        <button class="btn btn-dark button">{{ characters.out_of_stock }}</button>
                    </div>
                <div class="price ml-auto">{{ characters.soldout }}</div>
            </section>
            <section class="item-purchase" v-if="item.bought_flag==1">
                    <div>
                        <input type="hidden" name='id' :value="item.item_id">
                        <button class="btn btn-dark button">{{ characters.purchased }}</button>
                    </div>
            </section>
        </div>

        <div v-if="checkIsDigitalContent(item.type) && 2<=item.content_count">
                <div id="product-list" v-cloak>
                    <ul>
                        <li>
                            <label>{{ characters.package_purchase }}</label>
                            <input type="checkbox" :checked="isAllSelected" @click="selectAllDigicons">
                        </li>
                        <li v-for="digicon in digicons" v-bind:key="digicon.digicon_id">
                            <label class="music-title">{{ digicon.title }}</label>
                            <input v-if="digicon.bought_flag===0 && digicon.purchasable_flag==1" type="checkbox" v-model="selectedDigiconIds" :value="digicon.digicon_id">
                            <input v-if="digicon.bought_flag===1 || digicon.purchasable_flag==0" type="checkbox" disabled='disabled' checked='checked'>
                        </li>
                    </ul>
                </div>

                <section id="item-purchase" class="item-purchase" v-if="item.bought_flag==0">
                    <div>
                        <input hidden name='id' :value="item.item_id">
                        <button class="btn btn-dark button" @click="add_cart()">{{ characters.add_cart }}</button>
                    </div>
                    <div class="price ml-auto">￥{{ price.toLocaleString() }}</div>
                </section>
                <section id="item-purchase" class="item-purchase" v-if="item.bought_flag==1">
                    <div>
                        <input hidden name='id' :value="item.item_id">
                        <button class="btn btn-dark button">{{ characters.purchased }}</button>
                    </div>
                </section>
        </div>

        <div v-if="loginModal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper" @click.self="closeModal()">
                        <div class="modal-container">
                            <div class="modal-body">
                                <p>{{ characters.need_login_to_purchase }}</p>
                                <a class="button-modal btn btn-dark" role="button" aria-pressed="true" :href="'/tmp_regist?item_id='+item_id">{{ characters.registration }}</a>
                                <a class="button-modal btn btn-dark" role="button" aria-pressed="true" :href="'/login?item_id='+item_id">{{ characters.login }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: "purchase",
        props: ['item_id', 'item_type_view_status', 'json_characters'],
        data: function () {
            return {
                tabs: [
                    {type: 'music', title: '音楽'},
                    {type: 'video', title: 'ビデオ'},
                    {type: 'goods', title: 'グッズ'},
                    {type: 'photo', title: '写真・画像'},
                    {type: 'ticket', title: 'チケット'},
                ],
                item: [],
                digicons: [],
                isAllSelected: false,
                selectedDigiconIds: [],
                price: 0,
                loginStatus: false,
                loginModal: false,
                boughtDigiconIds: [],
                characters: Object,
                boughtDigiconSumPrice: 0,
            }
        },
        mounted() {
            axios.all([
                axios.get('/store/detail/' + this.item_id),
                axios.post('/digicon/detail/' + this.item_id)
            ]).then(([response1, response2]) => {
                    this.item = response1.data;
                    this.digicons = response2.data;
                    for(let digicon in this.digicons) {
                        if(this.digicons[digicon].bought_flag===1 || this.digicons[digicon].purchasable_flag==0) {
                            this.boughtDigiconIds.push(this.digicons[digicon].digicon_id);
                            this.boughtDigiconSumPrice += this.digicons[digicon].price
                        } else {
                            this.selectedDigiconIds.push(this.digicons[digicon].digicon_id);
                        }
                    }
                    this.isAllSelected = true;
                    this.price = ((this.item.price - this.boughtDigiconSumPrice) < 0) ? 0 : (this.item.price - this.boughtDigiconSumPrice);
            })
            axios.default
                .get('/login/get')
                .then(response => {
                    this.loginStatus = response.data;
                });
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            selectAllDigicons () {
                if (this.isAllSelected) {
                    this.selectedDigiconIds = [];
                    this.isAllSelected = false;
                } else {
                    this.selectedDigiconIds = [];
                    for (let digicon in this.digicons) {
                        if(this.digicons[digicon].bought_flag===0 && this.digicons[digicon].purchasable_flag==1) {
                            this.selectedDigiconIds.push(this.digicons[digicon].digicon_id);
                        }
                    }
                    this.isAllSelected = true;
                }
            },
            select () {
                if (this.selectedDigiconIds.length !== (this.digicons.length - this.boughtDigiconIds.length)) {
                    this.isAllSelected = false;
                } else {
                    this.isAllSelected = true;
                }
            },
            add_cart() {
                if(this.loginStatus === false) {
                    this.loginModal=true;
                } else {
                    axios.default
                        .post('/cart/add', {item_id: this.item_id, selectedDigiconIds: this.selectedDigiconIds})
                        .then(response => {
                            if(response.data.error_kind) {
                                this.getErrorContent(response.data);
                            } else {
                                location.href="/cart/confirm";
                            }
                        });
                }
            },
            closeModal: function() {
                this.loginModal=false;
            },
            getErrorContent: function(data) {
                let error_kind = data.error_kind
                switch (error_kind) {
                    case 'duplicate':
                        alert(data.title + this.characters.exist_in_cart);
                        break;
                    case 'purchased':
                        alert(data.title + this.characters.already_purchased);
                        break;
                    case 'strange-type':
                        if(data.type=='goods') {
                            alert(this.characters.exist_goods_in_cart);
                        }
                        if(data.type=='digital') {
                            alert(this.characters.exist_digicon_in_cart);
                        }
                        break;
                    case 'soldout':
                        alert(data.title + this.characters.goods_is_soldout);
                        break;
                    case 'parameter-strange':
                        alert(this.characters.parameter_strange);
                        break;
                    default:
                        alert(this.characters[error_kind]);
                        break;
                }
            },
            getPrice: async function() {
                let selected_items = [];
                for(let selected_digicon_id in this.selectedDigiconIds) {
                    let array = {item_id: Number(this.item_id), digicon_id: this.selectedDigiconIds[selected_digicon_id]};
                    selected_items.push(array);
                }
                await axios.default
                    .post('/cart/item/calc', {item: selected_items})
                    .then(response => {
                        let items = response.data;
                        let price = 0;
                        for(let item in items) {
                            if(items[item]['zero_flag'] ==0) {
                                price += items[item]['price'];
                            }
                        }
                        this.price = price;
                    });
            },
            checkIsDigitalContent: function(type) {
                const digital_content = ['music', 'video', 'photo'];
                return digital_content.indexOf(type) > -1;
            },
        },
        watch: {
            selectedDigiconIds: function(newVal, oldVal) {
                this.selectedDigiconIds = newVal;
                if (this.selectedDigiconIds.length !== (this.digicons.length - this.boughtDigiconIds.length)) {
                    this.isAllSelected = false;
                    if(this.selectedDigiconIds.length !== 0) {
                        this.getPrice();
                    } else {
                        this.price = 0;
                    }
                } else {
                    this.isAllSelected = true;
                    if(this.selectedDigiconIds.length == this.digicons.length) {
                        this.price = this.item.price;
                    } else {
                        this.getPrice();
                    }
                }
            },
        }
    }
</script>

<style scoped>
</style>
